import { render, staticRenderFns } from "./LgbTeamMembersModify.vue?vue&type=template&id=a27ed940"
import script from "./LgbTeamMembersModify.vue?vue&type=script&lang=js"
export * from "./LgbTeamMembersModify.vue?vue&type=script&lang=js"
import style0 from "./LgbTeamMembersModify.vue?vue&type=style&index=0&id=a27ed940&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports